module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page page-landing"
  }, [(_vm.banner) ? _c('div', {
    staticClass: "columns is-gapless is-multiline",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "top-image-wrapper is-hidden-mobile",
    style: ({
      backgroundImage: ("url(" + (_vm.banner.image ? _vm.banner.image.path : '') + ")")
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "vcentered banner",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-once": "true"
    }
  }, [(_vm.banner.content) ? _c('markdown', {
    attrs: {
      "source": _vm.banner.content
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive is-hidden-tablet",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": _vm.banner.image_mobile && _vm.banner.image_mobile.path
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-image-wrapper is-hidden-tablet"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "vcentered banner",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-once": "true"
    }
  }, [(_vm.banner && _vm.banner.content) ? _c('markdown', {
    attrs: {
      "source": _vm.banner.content
    }
  }) : _vm._e()], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.statement && _vm.contacts) ? _c('div', {
    staticClass: "container",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless content"
  }, [_c('div', {
    staticClass: "column is-12 extra-padded"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              " + _vm._s(_vm.statement.title) + "\n            ")]), _vm._v(" "), (_vm.statement.content) ? _c('markdown', {
    attrs: {
      "source": _vm.statement.content
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              " + _vm._s(_vm.contacts.title) + "\n            ")]), _vm._v(" "), (_vm.contacts.content) ? _c('markdown', {
    attrs: {
      "source": _vm.contacts.content
    }
  }) : _vm._e()], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.note) ? _c('div', {
    staticClass: "container note color-blue color-yellow-bg",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "50px"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-12 smessage",
    staticStyle: {
      "padding": "30px"
    }
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container is-fluid color-gray-lighter-bg",
    staticStyle: {
      "padding-top": "15px",
      "padding-bottom": "45px",
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "container content"
  }, [_c('div', {
    staticClass: "columns has-text-centered"
  }, _vm._l((_vm.hotlinks), function(hotlink, index) {
    return _c('div', {
      key: ("" + (hotlink.id)),
      staticClass: "column is-4",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-once": "true",
        "data-aos-delay": (index + 1) * 200
      }
    }, [_c('a', {
      attrs: {
        "href": ("" + (hotlink.route))
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": hotlink.image ? hotlink.image.path : ''
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title tight margin-top"
    }, [_vm._v("\n              " + _vm._s(hotlink.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text tight margin-top"
    }, [_vm._v("\n              " + _vm._s(hotlink.content) + "\n            ")])])])
  }), 0)])]), _vm._v(" "), (_vm.testimonials) ? _c('div', {
    staticClass: "slick-wrapper",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.testimonials), function(item, index) {
    return _c('div', {
      key: ("" + (item.id)),
      staticClass: "item-wrapper",
      attrs: {
        "caption": item.title
      }
    }, [_c('div', {
      staticClass: "container is-fluid",
      staticStyle: {
        "padding-top": "30px",
        "padding-bottom": "30px",
        "margin-left": "0",
        "margin-right": "0"
      }
    }, [_c('div', {
      staticClass: "container content"
    }, [_c('div', {
      staticClass: "columns is-centered has-text-centered"
    }, [_c('div', {
      staticClass: "column is-7"
    }, [_c('div', {
      staticClass: "title tight margin-top"
    }, [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "text tight margin-top"
    }, [_vm._v("\n                  " + _vm._s(item.content) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "subtitle margin-top"
    }, [_vm._v("\n                  " + _vm._s(item.link) + "\n                ")])])])])])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('main-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "data": _vm.message || {}
    },
    on: {
      "onClose": _vm.onCloseDialog
    }
  }), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4885f45d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing.vue
// module id = 973
// module chunks = 1